module.exports = __webpack_public_path__ + "img/定位-生产基地.da8bb2a5.svg";